import { Reveal, ChapterHead } from "./Reveal";
import { useContent } from "@/content";

const PRINCIPLES = [
  { s: "PROTECT YOUR MIND.", d: "Be careful about what you let into your head every day." },
  { s: "DIRECT YOUR INTENTION.", d: "Decide what you're aiming at before the world decides for you." },
  { s: "QUESTION THE DEFAULT.", d: "Normal isn't always right. Ask why things are the way they are." },
  { s: "YOUR ATTENTION SHAPES YOUR REALITY.", d: "What you focus on quietly becomes your life." },
  { s: "CREATE. GROW. APPLY.", d: "Make things, learn from them, then put what you learned to work." },
  { s: "THE FUTURE IS BUILT IN THE PRESENT.", d: "Tomorrow is decided by what you do today." },
];

export const Philosophy = () => {
  const c = useContent();

  return (
    <section id="philosophy" className="px-6 sm:px-12 lg:px-20 py-24 sm:py-32 max-w-7xl mx-auto" data-testid="philosophy-section">
      <ChapterHead index="CHAPTER 02" title="PHILOSOPHY" />

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-5">
          <Reveal>
            <p className="font-meta text-xs tracking-[0.3em] text-blue-300/60 mb-6">THE WORLDVIEW</p>
            <p className="text-base sm:text-lg font-light leading-relaxed text-blue-100/70">
              {c.philosophy_p1 || "The mind is one of the most valuable things a person possesses — and modern society constantly competes for it. Algorithms, digital consumption, social media, advertising, institutions, cultural expectations, and technological systems can influence how people think without them ever noticing."}
            </p>
            <p className="text-base sm:text-lg font-light leading-relaxed text-blue-100/70 mt-6">
              {c.philosophy_p2 || "The work here begins with a refusal: protect your attention, question what you consume, recognize how environments shape identity, and build a perspective that exists outside the algorithm."}
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          {PRINCIPLES.map((p, i) => (
            <Reveal key={p.s} delay={i * 0.05}>
              <div
                className="group flex items-baseline gap-5 sm:gap-8 border-b border-blue-100/10 py-5 sm:py-6 px-2 sm:px-4 -mx-2 sm:-mx-4 hover:bg-[#4F7CFF] transition-colors duration-300"
                data-testid={`principle-${i}`}
              >
                <span className="font-meta text-[10px] sm:text-xs tracking-[0.25em] text-blue-300/50 group-hover:text-white/70 transition-colors duration-300 shrink-0">
                  0{i + 1}
                </span>
                <span className="font-display text-xl sm:text-3xl lg:text-4xl font-bold uppercase tracking-tight flex-1">
                  {p.s}
                </span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
